import 'css-chunk:../../src/features/floating-toolbar/components/modal-button/index.module.scss';export default {
  "wrapper": "_wrapper_pltfq_1",
  "button": "_button_pltfq_7",
  "label": "_label_pltfq_20"
};